
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pizza/panpizza",
      function () {
        return require("private-next-pages/pizza/panpizza/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pizza/panpizza"])
      });
    }
  